import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "../types";
import { Button as Component } from "./component";
const getButtonExtension = (name, disableResize) => [
  createRicosNodeExtension({
    groups: ["custom-styles", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, props, settings) => {
      return {
        ...config,
        disableResize,
        isTextWrap: props.isTextWrap ?? true,
        addOptions: () => settings
      };
    },
    Component,
    name,
    createExtensionConfig() {
      const HOVER_PREVIEW_PLUGIN_KEY = new PluginKey(this.name + "hoverPreview");
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          type: null,
          containerData: null,
          styles: null,
          text: null,
          link: null
        }),
        addCommands() {
          return {
            setHoverPreview: (applyPreview) => ({ tr, dispatch }) => {
              dispatch?.(tr.setMeta(HOVER_PREVIEW_PLUGIN_KEY, applyPreview));
              return true;
            }
          };
        },
        addProseMirrorPlugins() {
          return [
            new Plugin({
              key: HOVER_PREVIEW_PLUGIN_KEY,
              state: {
                init() {
                  return { applyPreview: false };
                },
                apply(tr, value) {
                  const applyPreview = tr.getMeta(HOVER_PREVIEW_PLUGIN_KEY);
                  if (applyPreview === void 0) {
                    return value;
                  }
                  return { applyPreview };
                }
              },
              props: {
                decorations(state) {
                  const { applyPreview } = HOVER_PREVIEW_PLUGIN_KEY.getState(state);
                  const { from, to } = state.selection;
                  if (!applyPreview) {
                    return null;
                  }
                  return DecorationSet.create(state.doc, [
                    Decoration.node(from, to, {
                      class: "forced-hover"
                    })
                  ]);
                }
              }
            })
          ];
        }
      };
    }
  })
];
const tiptapExtensionsMap = ({ disableResize }) => ({
  [LINK_BUTTON_TYPE]: getButtonExtension(TIPTAP_LINK_BUTTON_TYPE, disableResize),
  [ACTION_BUTTON_TYPE]: getButtonExtension(TIPTAP_ACTION_BUTTON_TYPE, disableResize)
});
export {
  tiptapExtensionsMap
};
//# sourceMappingURL=tiptap.js.map
